<template>
  <div>
    <div class="reporting-call-logs-header">
      <h2 v-t="'HEADER_EXPORT_BIDS'" class="reporting-call-logs-header__title" />
    </div>
    <div class="r-form display-flex flex--wrap p-b-30">
      <SearchableDropdown
        v-model="timeZoneId"
        rules="required"
        :config="timeZoneOptions"
        class="rtb-export-timezone m-r-15 m-b-15"
        :clearable="false"
      />
      <DateRangePickerSingle
        date-button-class="btn daterangepicker-btn--form m-r-15 m-b-15"
        :selected-date="selectedDate"
        :options="dateSelectConfig"
        :time-zone-id="translatedTimeZoneId"
        @onDateChange="onDateChange"
      />
      <PrimaryButton
        :show-loader-on-form="isExporting"
        type="button"
        class="p-l-15 m-b-15"
        :class="isExporting ? 'p-r-35' : 'p-r-15'"
        @click="onExportRtbLog"
      >
        <i class="fa fa-download" aria-hidden="true" />
        {{ $t('BUTTON_EXPORT_CSV') }}
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import 'moment-timezone';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { utilities, dateTimeService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import PrimaryButton from '@/core/components/PrimaryButton';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import DateRangePickerSingle from '@/core/components/DateRangePickerSingle/DateRangePickerSingle';

const timeZoneConfig = {
  reduce: (option) => option.id,
  label: 'display',
};

export default {
  name: 'RtbExport',
  components: {
    PrimaryButton,
    SearchableDropdown,
    DateRangePickerSingle
  },
  props: {
    campaignId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      timeRange: [],
      timeZoneId: '',
      selectedDate: null,
      isExporting: false
    }
  },
  computed: {
    ...mapState(['timezones']),
    ...mapGetters(['accountTimezoneId']),
    translatedTimeZoneId() {
      return dateTimeService.getTimeZoneMapping(this.timeZoneId);
    },
    dateSelectConfig() {
      const timezone = this.translatedTimeZoneId || moment.tz.guess();
      return {
        opens: 'right',
        timePicker: false,
        singleDatePicker: true,
        minDate: moment().tz(timezone).subtract(6, 'month').startOf('day')
      };
    },
    timeZoneOptions() {
      return {
        options: this.timezones,
        ...timeZoneConfig,
        placeholder: 'Select Timezone'
      };
    },
  },
  created() {
    if (!this.timezones?.length) {
      this.getTimezones();
    }
    this.timeZoneId = this.accountTimezoneId;
    this.selectedDate = moment().tz(this.translatedTimeZoneId);
    this.timeRange = [
      moment(this.selectedDate).startOf('day'),
      moment(this.selectedDate).endOf('day')
    ];
  },
  methods: {
    ...mapActions(['getTimezones']),
    ...mapActions('rtbLogs', ['exportRtbLog']),
    async onExportRtbLog() {
      this.isExporting = true;
      let filters = [];
      if (this.campaignId) {
        filters = [
          {
            anyConditionToMatch: [
              {
                column: 'campaignId',
                comparisonType: 'EQUALS',
                isNegativeMatch: false,
                value: this.campaignId
              }
            ]
          }
        ]
      }
      try {
        const request = {
          timeRange: this.timeRange,
          formatTimeZone: this.translatedTimeZoneId,
          filters: filters
        }
        await this.exportRtbLog(request);
      } catch(error) {
        console.error(error);
        utilities.errorHandler(error);
      } finally {
        this.isExporting = false;
      }
    },
    onDateChange(data) {
      this.timeRange = [
        moment(data).startOf('day'),
        moment(data).endOf('day')
      ];
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>
